import { Link, LinkProps, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const AppointmentDetailsContainer = styled("div")(({ theme }) => ({
  padding: "20px",
  backgroundColor: theme.palette.background.paper,
  borderRadius: 16,
  border: `1px solid ${theme.palette.secondary[300]}`,
  marginBottom: "16px",
}));

export const SpanTitle = styled("span")(({ theme }) => ({
  fontWeight: 700,
  marginRight: "6px",
  color: theme.palette.text.secondary,
}));

export const SpanDateValue = styled("span")(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 700,
}));

export const SpanValue = styled("span")(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const StyledLink = styled(Link)<LinkProps>(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.primary.main,
  fontWeight: 600,
  "&:hover": {
    textDecoration: "underline",
  },
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  border: `1px solid ${theme.palette.success.main}`,
  padding: "10px 14px",
  borderRadius: 12,
  cursor: "pointer",
  marginTop: "14px",
  transition: "all 0.2s ease",
  width: "fit-content",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));
